import {
	FETCH_MAINTENANCES_REQUEST,
	FETCH_MAINTENANCES_SUCCESS,
	FETCH_MAINTENANCES_FAIL,
	UPDATE_MAINTENANCE_REQUEST,
	UPDATE_MAINTENANCE_SUCCESS,
	UPDATE_MAINTENANCE_FAIL,
	FETCH_MAINTENANCE_REQUEST,
	FETCH_MAINTENANCE_SUCCESS,
	FETCH_MAINTENANCE_FAIL,
	CREATE_MAINTENANCE_REQUEST,
	CREATE_MAINTENANCE_SUCCESS,
	CREATE_MAINTENANCE_FAIL,
	DELETE_MAINTENANCE_REQUEST,
	DELETE_MAINTENANCE_SUCCESS,
	DELETE_MAINTENANCE_FAIL,
} from "../constants/maintenance";

function fetchMaintenancesReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
			maintenanceDeleted: false,
		};
	}
	switch (action.type) {
		case FETCH_MAINTENANCES_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_MAINTENANCES_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				maintenances: action.payload,
			};
		case FETCH_MAINTENANCES_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function updateMaintenanceReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case UPDATE_MAINTENANCE_REQUEST:
			return { loading: true };
		case UPDATE_MAINTENANCE_SUCCESS:
			return {
				loading: false,
				status: "SUCCEEDED",
			};
		case UPDATE_MAINTENANCE_FAIL:
			return { loading: false, status: "FAILED" };
		default:
			return state;
	}
}

function fetchMaintenanceReducer(state, action) {
	if (typeof state === "undefined") {
		state = { status: "IDLE", error: null };
	}
	switch (action.type) {
		case FETCH_MAINTENANCE_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_MAINTENANCE_SUCCESS:
			return {
				loading: false,
				status: "SUCCEEDED",
				maintenance: action.payload,
			};
		case FETCH_MAINTENANCE_FAIL:
			return { loading: false, status: "FAILED" };
		default:
			return state;
	}
}

function createMaintenanceReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case CREATE_MAINTENANCE_REQUEST:
			return { loading: true };
		case CREATE_MAINTENANCE_SUCCESS:
			return { loading: false, success: true, maintenance: action.payload };
		case CREATE_MAINTENANCE_FAIL:
			return { loading: false, success: false, error: action.payload };
		default:
			return state;
	}
}

function deleteMaintenanceReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case DELETE_MAINTENANCE_REQUEST:
			return { loading: true };
		case DELETE_MAINTENANCE_SUCCESS:
			return {
				loading: false,
				maintenanceDeleted: true,
			};
		case DELETE_MAINTENANCE_FAIL:
			return {
				loading: false,
				maintenanceDeleted: false,
				error: action.payload,
			};
		default:
			return state;
	}
}

export {
	fetchMaintenancesReducer,
	updateMaintenanceReducer,
	fetchMaintenanceReducer,
	createMaintenanceReducer,
	deleteMaintenanceReducer,
};
